module.exports = __webpack_public_path__ + "img/31-min.03e9fde2.jpg";